// <site-header> — mega menu (hover on desktop, tap on phone/keyboard), search + cart triggers, cart count.
const desk = window.matchMedia('(hover: hover) and (min-width: 1024px)');

class SiteHeader extends HTMLElement {
  connectedCallback() {
    this.btns = [...this.querySelectorAll('[aria-controls="mega"]')];
    this.open = false;

    this.querySelector('.shopbtn')?.addEventListener('mouseenter', () => desk.matches && this.set(true));
    this.querySelectorAll('[data-mega-close]').forEach((a) => a.addEventListener('mouseenter', () => desk.matches && this.set(false)));
    this.addEventListener('mouseleave', () => desk.matches && this.set(false));
    this.btns.forEach((b) => b.addEventListener('click', () => { this.last = b; this.set(!this.open); }));

    this.addEventListener('click', (e) => {
      const s = e.target.closest('[data-search-open]');
      if (s) { e.preventDefault(); this.set(false); document.dispatchEvent(new CustomEvent('search:open', { detail: { trigger: s } })); return; }
      const c = e.target.closest('[data-cart-open]');
      if (c && customElements.get('cart-drawer')) { e.preventDefault(); this.set(false); document.dispatchEvent(new CustomEvent('cart:open', { detail: { trigger: c } })); }
    });
    this.onKey = (e) => { if (e.key === 'Escape' && this.open) { this.set(false); (this.last || this.btns[0])?.focus(); } };
    this.onDoc = (e) => { if (this.open && !this.contains(e.target)) this.set(false); };
    this.onCart = (e) => this.setCount(e.detail?.item_count ?? 0);
    document.addEventListener('keydown', this.onKey);
    document.addEventListener('click', this.onDoc);
    document.addEventListener('cart:updated', this.onCart);
    // keyboard: leaving the mega with Tab closes it
    this.querySelector('.mega')?.addEventListener('focusout', (e) => {
      if (this.open && !this.contains(e.relatedTarget)) this.set(false);
    });
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('click', this.onDoc);
    document.removeEventListener('cart:updated', this.onCart);
  }
  set(on) {
    if (on === this.open) return;
    this.open = on;
    this.classList.toggle('mega-on', on);
    this.btns.forEach((b) => b.setAttribute('aria-expanded', String(on)));
  }
  setCount(n) {
    const a = this.querySelector('[data-cart-open]'); if (!a) return;
    const label = `${a.dataset.cartLabel} (${n})`;
    const span = a.querySelector('.roll > span');
    if (span) { span.textContent = label; span.dataset.t = label; }
    a.setAttribute('aria-label', a.getAttribute('aria-label').replace(/\d+/, n));
  }
}
if (!customElements.get('site-header')) customElements.define('site-header', SiteHeader);
